import { nanoid } from 'nanoid';

export const Projects = [
  {
    id: nanoid(),
    img: '/assets/projects/ymaneboot.PNG',
    title: 'WhatsApp Bulk messages',
    descrition: `A whatsapp bulk messsages plateforme`,
    tags: [
      'React JS',
      'NodeJS',
      'ExpressJS',
      'Whatsapp API',
      'JS',
      'GIT',
      'GitHub',
      'CI/CD',
    ],
    demo: 'https://youtu.be/ZhAWT5-Lf6Y',
  },
  {
    id: nanoid(),
    img: '/assets/projects/chatbot.png',
    title: 'WhatsApp Chatbot',
    descrition: `I've set up a WhatsApp chatbot that allows any camtrack customer to know the position of their vehicle in real time. 
        The real goal of this project is to extend the scope, operations and global reach through WhatsApp, personalize and automate customer interaction, 
        automate tasks and improve engagements (non-reporting, maintenance, etc.), optimize after-sales services with efficient chatbots 24/7 .`,
    tags: ['NodeJS', 'ExpressJS', 'Whatsapp API', 'JS', 'GIT', 'GitHub'],
    demo: 'https://youtu.be/6m4SGt_-7tI',
  },
  /*     {
        id:nanoid(),
        img:"/assets/projects/repportAuto.png",
        title:"Repport Automation",
        descrition:`The after-sales service department had to transmit certain infringement or journey reports in Excel format from the vehicle fleets to their customers on a weekly, monthly or even daily basis. 
        This was very tedious for the team, given the number of reports to customize and send. 
        Hence the creation of an application or platform to solve this problem.. `,
        tags:["NodeJS","ExpressJS","ExcelJS","JS","GIT","GitHub"],
        demo:"https://youtu.be/nOvJcABhGTE",
    }, */
  {
    id: nanoid(),
    img: '/assets/projects/Nasa-Project.PNG',
    title: 'Nasa Mission Controle Dashboard',
    descrition: `The nasa mission controle dashboard is a web app for Scheduling a mission launch for interstellar 
        travel to one of the Kepler ExoplanetsI used NodeJs-ExpressJs for the backend, ReactsJs for the frontend and 
        mongoDB atlas for the database.
        I used GitHub Actions for the continuous integration purpose, dockerize the app with Docker and deploy to aws Ec2 instance. `,
    tags: [
      'NodeJS',
      'ExpressJS',
      'MongoDB',
      'React JS',
      'Html',
      'CSS',
      'JS',
      'GIT',
      'GitHub',
      'Docker',
      'AWS',
    ],
    demo: 'https://nasa-project-8a7z.onrender.com/',
    code: 'https://github.com/sheiguey/Nasa-Project',
  },
  {
    id: nanoid(),
    img: '/assets/projects/tic-tac-toe.PNG',
    title: 'Tic-Tac-Toe',
    descrition: 'Tic-Tac-Toe game',
    tags: ['React JS', 'Html', 'CSS', 'JavaScript'],
    demo: 'https://ephemeral-griffin-43fb36.netlify.app',
    code: 'https://github.com/sheiguey/Tic-Tac-Toe',
  },
  {
    id: nanoid(),
    img: '/assets/projects/investment-calculator.png',
    title: 'Calculator investment',
    descrition: 'Investment calculator',
    tags: ['React JS', 'Html', 'CSS', 'JavaScript'],
    demo: 'https://splendorous-sable-4ef5d2.netlify.app',
    code: 'https://github.com/sheiguey/investment-calculator',
  },
  {
    id: nanoid(),
    img: '/assets/projects/capestone-project.png',
    title: 'CapeStone(Add To Cart)',
    descrition:
      'A mini-application with a few e-commerce site functionalities brings the useContext hook to the fore.',
    tags: ['React JS', 'Html', 'CSS', 'JavaScript'],
    demo: 'https://zippy-taiyaki-4dd2e5.netlify.app/',
    code: 'https://github.com/sheiguey/capestone-add-to-add-project',
  },
  {
    id: nanoid(),
    img: '/assets/projects/quizzicapp2.png',
    title: 'Quizzical App',
    descrition:
      'A quiz application based on the Trivia API to test your general knowledge.',
    tags: ['React JS', 'Html', 'CSS', 'JavaScrit'],
    demo: 'https://harmonious-kheer-83e216.netlify.app/',
    code: 'https://github.com/sheiguey/Quizzical-App',
  },
  {
    id: nanoid(),
    img: '/assets/projects/tenzies-Game.png',
    title: 'Tensie Game',
    descrition:
      "A dice game application. Allows you to choose single-digit dice in turn. At the end, you'll be shown the number of turns, the time taken and the minimum time.",
    tags: ['React JS', 'Html', 'CSS', 'JavaScrit'],
    demo: 'https://merry-flan-3ec6fc.netlify.app/',
    code: 'https://github.com/sheiguey/Tenzies-Game',
  },
  {
    id: nanoid(),
    img: '/assets/projects/Budgeties-App.png',
    title: 'Budgetie App',
    descrition:
      'An application for recording expenses in one period, with the possibility of filtering by year and viewing the rate of expenses by month.',
    tags: ['React JS', 'Html', 'CSS', 'JavaScrit'],
    demo: 'https://iridescent-tarsier-afc635.netlify.app/',
    code: 'https://github.com/sheiguey/Expensive',
  },
  {
    id: nanoid(),
    img: '/assets/projects/zencollect.png',
    title: 'Zencollect',
    descrition:
      'This platform enables microfinance collectors to carry out their operations in the field from a mobile application in complete security, and gives the microfinance company real-time control over the cash inflows and outflows of its collection agents in the field. It also enables customers to track all their transactions via a mobile application.',
    tags: ['React JS', 'Html', 'CSS', 'JavaScrit', 'Bootstrap', 'Git'],
    demo: 'https://youtu.be/aFNq3I7Qqrc',
  },
  {
    id: nanoid(),
    img: '/assets/projects/bulksms.png',
    title: 'BulkSMS',
    descrition: 'A bulk messages App',
    tags: ['React JS', 'Html', 'CSS', 'JavaScrit', 'Bootstrap', 'Git'],
    demo: 'hhttps://youtu.be/5YYUTr5nE20',
  },
  {
    id: nanoid(),
    img: '/assets/projects/zencarto.png',
    title: 'Zencarto',
    descrition:
      'An urban community application for collecting and mapping data on taxpayers in a geographical area, offering excellent tracking of tax payments.',
    tags: [
      'React JS',
      'Html',
      'CSS',
      'JavaScrit',
      'Bootstrap',
      'Git',
      'PostgresSQL',
    ],
  },
  {
    id: nanoid(),
    img: '/assets/projects/zenoutdoor.png',
    title: 'Zenoutdoor',
    descrition:
      'Application for collecting and geolocating points of sale, billboards and other points of interest.',
    tags: [
      'PHP',
      'CodeIgniter',
      'Html',
      'CSS',
      'JavaScrit',
      'Bootstrap',
      'Git',
      'PostgresSQL',
    ],
    demo: 'https://youtu.be/OMOyUhhtGMk',
  },
  {
    id: nanoid(),
    img: '/assets/projects/unit-conversion.png',
    title: 'Metric/Imperial Unit Conversion',
    descrition: 'Simple Js application for converting units of measurement.',
    tags: ['Html', 'CSS', 'JavaScrit'],
    demo: 'https://radiant-mandazi-a2c917.netlify.app/',
    code: 'https://github.com/sheiguey/Unit-converter',
  },
];
